<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  name: { type: String, required: true },
  description: { type: String, default: '' },
  statusText: { type: String, default: '' },
  enabled: { type: Boolean, default: false },
  to: { type: [String, Object], required: true },
  logoSrc: { type: String, default: '' },
  icon: { type: String, default: '' },
});

const { t } = useI18n();

const statusLabel = computed(() =>
  props.enabled
    ? t('INTEGRATION_APPS.STATUS.ENABLED')
    : t('INTEGRATION_APPS.STATUS.DISABLED')
);

const statusColor = computed(() =>
  props.enabled ? 'bg-n-teal-9' : 'bg-n-slate-8'
);
</script>

<template>
  <div
    class="m-[1px] flex flex-1 flex-col rounded-md bg-n-alpha-3 p-6 shadow outline outline-1 outline-n-container"
  >
    <div class="mb-4 flex items-start justify-between">
      <div class="flex h-12 w-12">
        <img
          v-if="logoSrc"
          :src="logoSrc"
          :alt="name"
          class="max-w-full rounded-md border border-n-weak bg-n-alpha-3 object-contain shadow-sm dark:bg-n-alpha-2"
        />
        <div
          v-else
          class="flex h-full w-full items-center justify-center rounded-md border border-n-weak bg-n-alpha-3 dark:bg-n-alpha-2"
        >
          <Icon
            v-if="icon"
            :icon="icon"
            class="size-6 text-n-slate-11"
          />
        </div>
      </div>
      <span
        v-tooltip="statusLabel"
        class="flex h-5 w-5 items-center justify-center rounded-full p-0.5 text-white"
        :class="statusColor"
      >
        <i class="i-ph-check-bold text-sm" />
      </span>
    </div>
    <div class="m-0 flex flex-1 flex-col">
      <div
        class="mb-2 flex items-center justify-between font-medium text-n-slate-12"
      >
        <span class="text-base font-semibold">{{ name }}</span>
        <router-link :to="to">
          <Button :label="t('INTEGRATION_APPS.CONFIGURE')" link />
        </router-link>
      </div>
      <p v-if="description" class="text-n-slate-11">{{ description }}</p>
      <p v-if="statusText" class="mt-2 text-sm text-n-slate-10">
        {{ statusText }}
      </p>
    </div>
  </div>
</template>
